import {
  Button,
  Input,
  Popover,
  PopoverContent,
  PopoverHandler,
  Typography,
} from "@material-tailwind/react";
import NoAdmins from "../../../components/settings/NoAdmins";
import { useMutation, useQuery } from "react-query";
import ApiRoutes from "../../../services/apiRoutes";
import api from "../../../services/apiService";
import DefaultLoading from "../../../components/common/DefaultLoading";
import { AdminResponse } from "../../../models/settings/admins";
import { MdDeleteForever } from "react-icons/md";
import { RiSearchFill } from "react-icons/ri";
import { useState } from "react";
import ClickBaseButton from "../../../components/common/buttons/ClickBaseButton";
import AddRole from "./AddRole";
import { TfiMenuAlt } from "react-icons/tfi";
import { toast } from "react-toastify";
import { handleErrorMessage } from "../../../utility";

function Administrator() {
  const { data, isLoading, refetch } = useQuery(
    "get All Admins",
    () => api.get<AdminResponse>(ApiRoutes.getAdmins),
    {
      onSuccess(data) {
        console.log(data);
        // console.log(data.data.data[0].firstName);
      },
      onError(error) {
        console.log(error);
      },
    }
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const TABLE_HEAD = ["Name", "Email", "Role", "Status", "Actions"];

  const activateAccountMutation = useMutation(
    (id: string | number) => {
      return api.delete(`${ApiRoutes.disableAdmin}${id}`);
    },
    {
      onSuccess(data) {
        toast.success(data.data.statusMessage);
        refetch();
      },
      onError(error: { statusMessage?: string }) {
        console.log(error);

        handleErrorMessage(
          error.statusMessage,
          "unable to remove user, try again later."
        );
      },
    }
  );

  if (isLoading) {
    return <DefaultLoading />;
  }

  if (data?.data.payload.data.length === 0) {
    return <NoAdmins handleOpen={() => setOpenDialog(!openDialog)} />;
  }

  return (
    <div>
      <AddRole
        open={openDialog}
        getAdmins={refetch}
        handleOpen={() => setOpenDialog(!openDialog)}
      />
      <section>
        <div className="md:flex justify-between items-center">
          <div className="md:w-1/3 py-6">
            <Input
              crossOrigin={undefined}
              icon={<RiSearchFill />}
              label="Search for admin"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <ClickBaseButton
            className="w-full md:w-1/3 lg:w1/6 mt-0 rounded-2xl"
            onClick={() => {
              setOpenDialog(true);
            }}
          >
            Add An Admin
          </ClickBaseButton>
        </div>
      </section>
      <div className="overflow-x-auto">
        <table className=" table-auto text-left w-full">
          <thead>
            <tr>
              {TABLE_HEAD.map((head) => (
                <th key={head} className=" p-4">
                  <Typography
                    placeholder={undefined}
                    variant="small"
                    color="blue-gray"
                    className="font-normal leading-none opacity-70"
                  >
                    {head}
                  </Typography>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white rounded-xl">
            {data!.data.payload.data
              .filter(
                (admin) =>
                  admin.firstname
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase()) ||
                  admin.emailAddress
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase())
              )
              .map((user, index) => {
                const isLast = index === data!.data.payload.data.length - 1;
                const classes = `p-4 ${
                  isLast ? "" : "border-b border-blue-gray-50"
                } ${index % 2 ? "bg-transparent" : ""}`;
                return (
                  <tr key={index}>
                    <td className={classes}>
                      <Typography
                        placeholder={undefined}
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                      >
                        {index + 1}
                      </Typography>
                    </td>
                    <td className={classes}>
                      <Typography
                        placeholder={undefined}
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                      >
                        {`${user.firstname} ${user.lastname}`}
                      </Typography>
                    </td>
                    <td className={classes}>
                      <Typography
                        placeholder={undefined}
                        variant="small"
                        color="blue-gray"
                        className="font-normal"
                      >
                        {user.emailAddress}
                      </Typography>
                    </td>
                    <td className={classes}>
                      <Typography
                        placeholder={undefined}
                        as="a"
                        href="#"
                        variant="small"
                        color="blue-gray"
                        className="font-medium"
                      >
                        {user.isDeleted !== true ? "Active" : "Inactive"}
                      </Typography>
                    </td>
                    <td className={classes}>
                      <Popover>
                        <PopoverHandler>
                          <Button
                            placeholder={undefined}
                            className="bg-transparent shadow-none"
                          >
                            <TfiMenuAlt color={"black"} />
                          </Button>
                        </PopoverHandler>
                        <PopoverContent placeholder={undefined}>
                          <div
                            className="flex hover:shadow-md p-2 cursor-pointer"
                            onClick={() =>
                              activateAccountMutation.mutate(user.id)
                            }
                          >
                            <MdDeleteForever
                              size={24}
                              color={"red"}
                              className="cursor-pointer mr-2"
                            />
                            <Typography
                              placeholder={undefined}
                              className="text-primary"
                            >
                              Disable User
                            </Typography>
                          </div>
                        </PopoverContent>
                      </Popover>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Administrator;
